export default {"src":"/_next/static/media/cde_icon.8b26bf77.svg","height":28,"width":28};